import React from 'react';
import {EyeIcon, EyeSlashIcon} from '@heroicons/react/24/outline';
import {useEditorStyle} from 'hooks';
import type {IChildrenProps} from './Editor.Inspector';

interface IEditorInspectorVisibleProps extends IChildrenProps {
  defaultDisplay?: 'block' | 'flex';
}

const EditorInspectorVisible = ({style, setProp, defaultDisplay = 'block'}: IEditorInspectorVisibleProps) => {
  const {updateStyle} = useEditorStyle({setProp});
  return (
    <div className="flex items-center justify-between">
      <p className="text-sm">Visible</p>
      <button
        type="button"
        className="cursor-pointer hover:brightness-120"
        onClick={() => {
          updateStyle('display', style?.display === 'none' ? defaultDisplay : 'none');
        }}>
        {style?.display !== 'none' ? <EyeIcon className="text-primary size-5" /> : <EyeSlashIcon className="size-5" />}
      </button>
    </div>
  );
};

export default React.memo(EditorInspectorVisible);
